import { render, staticRenderFns } from "./settlement_account.vue?vue&type=template&id=7319ccb4&"
import script from "./settlement_account.vue?vue&type=script&lang=ts&"
export * from "./settlement_account.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports